export const contactData = {
  YOUR_EMAIL: 'l.vukanovic32@gmail.com',
  GITHUB_URL: 'https://github.com/vukan322',
  LINKEDIN_URL: 'https://www.linkedin.com/in/luka-vukanovic/',
  CV_URL: `${import.meta.env.BASE_URL}/assets/Luka_Vukanovic-CV.pdf`,
};

export const navLinks = [
  { id: 'hero' },
  { id: 'about' },
  { id: 'experience' },
  { id: 'projects' },
  { id: 'contact' },
];

const technologies = [
  {
    category: 'tech.backend',
    items: [
      { name: 'tech.golang', color: '#00acd7' },
      { name: 'tech.nodejs', color: '#5fa04e' },
      { name: 'tech.nestjs', color: '#df234f' },
      { name: 'tech.expressjs', color: '#ffffff' },
    ],
  },
  {
    category: 'tech.frontend',
    items: [
      { name: 'tech.typescript', color: '#007acc' },
      { name: 'tech.react', color: '#61DAFB' },
      { name: 'tech.angular', color: '#DD0031' },
    ],
  },
  {
    category: 'tech.database',
    items: [
      { name: 'tech.postgresql', color: '#336791' },
      { name: 'tech.mysql', color: '#00618A' },
      { name: 'tech.mongodb', color: '#439934' },
    ],
  },
  {
    category: 'tech.tools',
    items: [
      { name: 'tech.git', color: '#F34F29' },
      { name: 'tech.docker', color: '#00AADA' },
      { name: 'tech.aws', color: '#f90' },
    ],
  },
  {
    category: 'tech.scripting',
    items: [
      { name: 'tech.python', color: '#FFD43B' },
      { name: 'tech.lua', color: '#000080' },
    ],
  },
];

const experiences = [
  {
    company_name: 'experience.kantech.name',
    date: 'experience.kantech.date',
    position: 'experience.kantech.position',
    summary: 'experience.kantech.summary',
    logo: '/assets/kantech-logo.webp',
    technologies: [
      'tech.golang',
      'tech.postgresql',
      'tech.nodejs',
      'tech.react',
      'tech.angular',
      'tech.python',
    ],
    url: 'https://www.kantech.dev/',
  },
  {
    company_name: 'experience.infinity.name',
    date: 'experience.infinity.date',
    position: 'experience.infinity.position',
    summary: 'experience.infinity.summary',
    logo: '/assets/infinity-dev-logo.webp',
    technologies: [
      'tech.springboot',
      'tech.javaswimos',
      'tech.postgresql',
      'tech.nodejs',
      'tech.react',
    ],
    url: 'https://infinitydev.rs/',
  },
  {
    company_name: 'experience.hds.name',
    date: 'experience.hds.date',
    position: 'experience.hds.position',
    summary: 'experience.hds.summary',
    logo: '/assets/hds-logo.webp',
    technologies: [
      'tech.typescript',
      'tech.nodejs',
      'tech.expressjs',
      'tech.nestjs',
      'tech.postgresql',
      'tech.react',
      'tech.angular',
      'tech.tailwind',
    ],
    url: 'https://holistic-digital.com/',
  },
];

const projects = [
  {
    name: 'projects.gamiotics.name',
    client: 'Gamiotics Inc.',
    position: 'projects.gamiotics.position',
    image: '/assets/projects/gamiotics/gamiotics-logo.png',
    isImageLogo: true,
    live_url: '',
    source_code_link: '',
    client_url: 'https://www.gamiotics.com/',
    tags: [
      { name: 'tech.springboot', color: 'text-green-500' },
      {
        name: 'tech.javaswimos',
        color: 'text-green-600',
      },
      { name: 'tech.aws', color: 'text-orange-500' },
      {
        name: 'tech.react',
        color: 'text-cyan-500',
      },
      { name: 'tech.redux', color: 'text-purple-500' },
      { name: 'tech.nodejs', color: 'text-green-400' },
    ],
  },
  {
    name: 'projects.equipment_tracker.name',
    client: 'Javno Komunalno Preduzeće "TOPLANA-ŠABAC"',
    position: 'projects.equipment_tracker.position',
    image:
      '/assets/projects/equipment-tracker/equipment-tracker-home-page-main.webp',
    isImageLogo: false,
    live_url: '',
    source_code_link: '',
    client_url: '',
    tags: [
      { name: 'tech.golang', color: 'text-blue-400' },
      {
        name: 'tech.react',
        color: 'text-cyan-500',
      },
      { name: 'tech.postgresql', color: 'text-blue-600' },
    ],
  },
  {
    name: 'projects.dispatcher_software.name',
    client: 'Javno Komunalno Preduzeće "TOPLANA-ŠABAC"',
    position: 'projects.dispatcher_software.position',
    image:
      '/assets/projects/dispatcher-software/dispatcher-software-home-page-main.webp',
    isImageLogo: false,
    live_url: '',
    source_code_link: '',
    client_url: '',
    tags: [
      { name: 'tech.golang', color: 'text-blue-400' },
      {
        name: 'tech.react',
        color: 'text-cyan-500',
      },
      { name: 'tech.postgresql', color: 'text-blue-600' },
    ],
  },
  {
    name: 'projects.work_log.name',
    client: 'Ingel d.o.o. Rakovac',
    position: 'projects.work_log.position',
    image: '/assets/projects/ingel-work-log/ingel-work-log.png',
    isImageLogo: false,
    live_url: '',
    source_code_link: '',
    client_url: 'https://ingel.co.rs/',
    tags: [
      { name: 'tech.golang', color: 'text-blue-400' },
      {
        name: 'tech.react',
        color: 'text-cyan-500',
      },
      { name: 'tech.postgresql', color: 'text-blue-600' },
    ],
  },
  {
    name: 'projects.conference_meet.name',
    client: 'InfinityDev',
    position: 'projects.conference_meet.position',
    image: '/assets/projects/conference-meet/conference-meet-home-page.webp',
    isImageLogo: false,
    live_url: 'https://conference-meet.infinitydev.rs/',
    source_code_link: '',
    client_url: 'https://infinitydev.rs/',
    tags: [
      { name: 'tech.angular', color: 'text-red-400' },
      {
        name: 'tech.oauth',
        color: 'text-blue-400',
      },
      { name: 'tech.jitsi', color: 'text-cyan-500' },
    ],
  },
  {
    name: 'projects.echogram.name',
    client: 'NOTIX d.o.o. BEOGRAD',
    position: 'projects.echogram.position',
    image: '/assets/projects/echogram/echogram.png',
    isImageLogo: false,
    live_url: 'https://beta.echogram.me',
    source_code_link: '',
    client_url: '',
    tags: [
      { name: 'tech.golang', color: 'text-blue-400' },
      {
        name: 'tech.mysql',
        color: '#FFFFFF',
      },
      {
        name: 'tech.oauth',
        color: 'text-blue-400',
      },
    ],
  },
  {
    name: 'projects.kantech.name',
    client: 'PR Agencija za računarsko programiranje KanTech',
    position: 'projects.kantech.position',
    image: '/assets/projects/kantech/kantech-site.png',
    isImageLogo: false,
    live_url: 'https://kantech.dev',
    source_code_link: '',
    client_url: '',
    tags: [{ name: 'tech.react', color: 'text-cyan-500' }],
  },
  {
    name: 'projects.belgrand.name',
    client: 'ANTENA-NET d.o.o.',
    position: 'projects.belgrand.position',
    image: '/assets/projects/belgrand/belgrand-logo-white.png',
    isImageLogo: true,
    // live_url: "https://conference-meet.infinitydev.rs/",
    source_code_link: '',
    client_url: 'https://belgrand.net/',
    tags: [
      //      { name: 'tech.react', color: 'text-cyan-500' },
      //      { name: 'tech.electron', color: '#FFFFFF' },
    ],
  },
  {
    name: 'projects.yt-downloader.name',
    client: 'projects.personal_project',
    position: 'projects.yt-downloader.position',
    image: '/assets/projects/yt-downloader/yt-downloader-main.png',
    isImageLogo: false,
    live_url: 'https://lukavukanovic.xyz/yt-downloader/',
    source_code_link: 'https://github.com/vukan322/yt-mp3-go',
    client_url: '',
    tags: [
      { name: 'tech.golang', color: 'text-blue-400' },
      { name: 'tech.javascript', color: 'text-yellow-400' },
    ],
  },
  {
    name: 'projects.ijot.name',
    client: 'projects.personal_project',
    position: 'projects.ijot.position',
    image: '/assets/projects/ijot/ijot.png',
    isImageLogo: false,
    live_url: '',
    // source_code_link: "https://github.com/vukan322/ijot",
    source_code_link: '',
    client_url: '',
    tags: [
      { name: 'tech.golang', color: 'text-blue-400' },
      {
        name: 'tech.react',
        color: 'text-cyan-500',
      },
      { name: 'tech.docker', color: 'text-blue-500' },
      {
        name: 'tech.tiptap',
        color: 'text-purple-500',
      },
      { name: 'tech.ollama', color: 'text-white' },
    ],
  },
  {
    name: 'projects.nukenm.name',
    client: 'projects.personal_project',
    position: 'projects.nukenm.position',
    image: '/assets/projects/nukenm/nuke-node_modules.png',
    isImageLogo: true,
    live_url: '',
    source_code_link: 'https://github.com/vukan322/nuke-node_modules',
    // source_code_link: '',
    client_url: '',
    tags: [{ name: 'tech.golang', color: 'text-blue-400' }],
  },
  {
    name: 'projects.dev-metrics.name',
    client: 'projects.personal_project',
    position: 'projects.dev-metrics.position',
    image: '/assets/projects/devmetrics/devmetrics.svg',
    isImageLogo: true,
    live_url: '',
    source_code_link: 'https://github.com/vukan322/devmetrics',
    client_url: '',
    tags: [
      { name: 'tech.golang', color: 'text-blue-400' },
      // {
      //   name: 'tech.react',
      //   color: 'text-cyan-500',
      // },
      // { name: 'tech.docker', color: 'text-blue-500' },
      // { name: 'tech.ollama', color: 'text-white' },
    ],
  },
  {
    name: 'projects.agency_finance_dashboard.name',
    client: 'projects.personal_project',
    position: 'projects.agency_finance_dashboard.position',
    image: '/assets/projects/project-coming-soon.webp',
    isImageLogo: false,
    live_url: '',
    // source_code_link: ",
    source_code_link: '',
    client_url: '',
    tags: [
      { name: 'tech.golang', color: 'text-blue-400' },
      {
        name: 'tech.react',
        color: 'text-cyan-500',
      },
      { name: 'tech.docker', color: 'text-blue-500' },
      { name: 'tech.ollama', color: 'text-white' },
    ],
  },
  // {
  //     name: "projects.reading_tracker.name",
  //     client: "projects.personal_project",
  //     position: "projects.reading_tracker.position",
  //     image: "/assets/projects/project-coming-soon.webp",
  //     isImageLogo: false,
  //     live_url: "",
  //     source_code_link: "https://github.com/vukan322/reading-tracker",
  //     client_url: '',
  //     tags: [{name: "tech.golang", color: "text-blue-400"}, {
  //         name: "tech.react",
  //         color: "text-cyan-500"
  //     }, {name: "tech.postgresql", color: "text-blue-600"}, {name: "tech.docker", color: "text-blue-500"},],
  // },
];

export { experiences, technologies, projects };
